import React, { useEffect, useState } from 'react';
import { getKategoriesDataAPI } from '../../API/kategories';
import {
    addCategoryAttribute,
    removeCategoryAttribute,
    fetchAiTags,
    fetchCatAttributeStats,
    updateCategoryAttribute, addCategoryEinheits, updateCategoryUnits
} from '../../API/annotatorApi';
import { Modal, Button, ButtonGroup, Row, Col, Form } from 'react-bootstrap';
import { Multiselect } from 'multiselect-react-dropdown';
import Loader from 'react-loader-advanced';
import Oval from 'react-loader-spinner';
import '../../Styles/Annotator/RisksDetection.css';

function RisksDetectionModal(props) {

    const [categories, setCategories] = useState([]);
    const [isEinheit, setIsEinheit] = useState(false);
    const [selectedEinheits, setSelectedEinheits] = useState([]);
    const [aiTags, setAiTags] = useState([]);
    const [catAttrStats, setCatAttrStats] = useState([]);
    const [category, setCategory] = useState('');
    const [aiTag, setAiTag] = useState('');
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);

    const [showEditCatAttr, setShowEditCatAttr] = useState(false);
    const [showEditCatUnits, setShowEditCatUnits] = useState(false);
    const [risksItem, setRisksItem] = useState(null);
    const handleEditCatAttrModalClose = () => {
        setShowEditCatAttr(false);
        setRisksItem(null);
    }

    const handleEditCatUnitsModalClose = () => {
        setShowEditCatUnits(false);
        setRisksItem(null);
    }
    const handleChildModalShow = (risksItem) => {
        setRisksItem(risksItem)
        if ('AI_tag' in risksItem) {
            setShowEditCatAttr(true);
        } else {
            setShowEditCatUnits(true);
        }
    }

    const buildStats = (risksItem) => {
        let output = [];
        if ('units' in risksItem) {
            return risksItem.units.join(', ')
        } else if (risksItem.values.length > 0) {
            const sorted_vals = risksItem.values.sort((a, b) => b.percentage - a.percentage);
            sorted_vals.forEach((val) => {
                output.push("\"" + val.value + "\": " + val.percentage + "%");
            });
            return output.join(", ");
        }
        return "Not defined";
    }

    const filteredData = catAttrStats.filter((risksItem) =>
        risksItem.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (risksItem.AI_tag?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (risksItem.units && risksItem.units.some(unit => unit.toLowerCase().includes(searchTerm.toLowerCase())))) ||
        risksItem.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(filteredData.length / itemsPerPage); i++) {
        pageNumbers.push(i);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const renderItems = currentItems.map((risksItem, index) => (
        <tr key={index}>
            <td>{risksItem.category}</td>
            <td>{risksItem.AI_tag ?? '-----'}</td>
            <td>{risksItem.name}</td>
            <td>{risksItem.description}</td>
            <td>{buildStats(risksItem)}</td>
            <td>
                <ButtonGroup>
                    <Button size="sm" style={{ margin: '0 2px' }}
                            onClick={() => handleChildModalShow(JSON.parse(JSON.stringify(risksItem)))}>Edit</Button>
                    <Button size="sm" style={{ margin: '0 2px' }}
                            onClick={() => handleRemoveCategoryAttribute(risksItem)}>Delete</Button>
                </ButtonGroup>
            </td>
        </tr>
    ));

    useEffect(() => {
        if (props.show) {
            const fetchData = async () => {
                try {
                    setLoading(true);

                    const [categories, aiTags, catAttrStats] =
                        await Promise.all([getKategoriesDataAPI(), fetchAiTags(), fetchCatAttributeStats()]);

                    setCategories(categories.map(cat => cat["category"]).sort());
                    setAiTags(aiTags["response"]);
                    setCatAttrStats(catAttrStats["response"]);
                } catch (error) {
                    console.log(error);
                } finally {
                    setLoading(false);
                }
            };
            fetchData();
        }
    }, [props.show]);

    useEffect(() => {
        if (!props.show) {
            return;
        }
        if (isEinheit) {
            if (name.trim() !== '') {
                const name_parts = name.split('_');
                name_parts[name_parts.length - 1] = "Einheiten";
                setName(name_parts.join('_'));
            }
        } else {
            const name_parts = name.split('_');
            name_parts[name_parts.length - 1] = aiTag;
            setName(name_parts.join('_'));
        }
    }, [isEinheit]);

    if (!props.show) {
        return null;
    }

    const handleCategorySelect = (e) => {
        let category = e.target.value.replace(/(<([^>]+)>)/ig, '');
        setCategory(category);
        let name = "";
        if (category !== "") {
            if (isEinheit) {
                name = category + "_" + "Einheiten";
            } else if (aiTag !== "") {
                name = category + "_" + aiTag;
            }
        }
        setName(name);
    }

    const handleAiTagSelect = (e) => {
        let aiTag = e.target.value.replace(/(<([^>]+)>)/ig, '');
        setAiTag(aiTag);
        let name = "";
        if (aiTag !== "" || category !== "") {
            name = category + "_" + aiTag
        }
        setName(name);
    }

    const resetState = () => {
        setCategory("");
        setAiTag("");
        setName("");
        setDescription("");
    }

    const handleOnHide = () => {
        props.onHide();
        resetState();
    }

    const validateForm = () => {
        if (isEinheit) {
            return category.trim() === "" || selectedEinheits.length === 0 || name.trim() === "";
        }
        return category.trim() === "" || aiTag.trim() === "" || name.trim() === "";
    }

    const handleAddCategoryAttribute = async () => {
        setLoading(true);
        const updated_stats = isEinheit ?
            await addCategoryEinheits(category, selectedEinheits, name, description) :
            await addCategoryAttribute(category, aiTag, name, description);
        setCatAttrStats(updated_stats.response);
        setLoading(false);
        resetState();
    }

    const handleRemoveCategoryAttribute = async (risksItem) => {
        setLoading(true);
        const updated_stats = await removeCategoryAttribute(risksItem.stat_id, risksItem.attr_id);
        setCatAttrStats(updated_stats.response);
        setLoading(false);
    }
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };

    const handleAddPair = () => {
        let risksItemCopy = JSON.parse(JSON.stringify(risksItem))
        risksItemCopy.values.push({value: "", count: ""});
        setRisksItem(risksItemCopy);
    }

    const handleDeletePair = (index) => {
        let risksItemCopy = JSON.parse(JSON.stringify(risksItem))
        risksItemCopy.values.splice(index, 1);
        setRisksItem(risksItemCopy);
    }

    const EditCategoryAttributeModal = ({risksItem}) => {
        if (risksItem == null || !('AI_tag' in risksItem)) {
            return null;
        }
        const [name, setName] = useState(risksItem.name);
        const [description, setDescription] = useState(risksItem.description);
        const [values, setValues] = useState(risksItem.values.map(({value, count}) => ({value, count})));

        useEffect(() => {
            setName(risksItem.name);
            setDescription(risksItem.description);
            setValues(risksItem.values.map(({value, count}) => ({value, count})));
        }, [risksItem]);

        const isFormInvalid = () => {
            return name.trim() === '' || values.some(obj => obj.value.toString().trim() === '' || obj.count.toString().trim() === '');
        }

        const handleValueChange = (index, field, newValue) => {
            const updatedValues = values.map((value, i) =>
                i === index ? { ...value, [field]: newValue } : value
            );
            setValues(updatedValues);
        };

        const handleSaveCatAttrChanges = async () => {
            const updatedItem = { ...risksItem, name, description, values };
            const updated_stats = await updateCategoryAttribute(updatedItem);
            handleEditCatAttrModalClose();
            setLoading(true);
            setCatAttrStats(updated_stats.response);
            setLoading(false);
        }

        return (
            <Modal show={showEditCatAttr} dialogClassName="risks-child-modal" onHide={handleEditCatAttrModalClose}
                    aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit {name}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="risks-child-modal-body">
                    {
                        <>
                            <h6>Name</h6>
                            <div>
                                <input type="text" className="risks-child-modal-input" value={name}
                                       onChange={(e) => {setName(e.target.value)}}/>
                            </div><br/>
                            <h6>Description</h6>
                            <div>
                                <input type="text" className="risks-child-modal-input" value={description}
                                       onChange={(e) => {setDescription(e.target.value)}}
                                       placeholder="Description" />
                            </div><br/>
                            <h6>Values</h6>
                            <table className="risks-edit-table">
                                <thead>
                                <tr>
                                    <th>Value</th>
                                    <th>Count</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    values.map((pair, index) => (
                                        <tr key={index}>
                                            <td><input type="text" value={pair.value}
                                                       onChange={(e) => {handleValueChange(index, 'value', e.target.value)}} /></td>
                                            <td><input type="text" value={pair.count}
                                                       onChange={(e) => {handleValueChange(index, 'count', e.target.value)}}/></td>
                                            <td><Button size="sm"
                                                        onClick={() => handleDeletePair(index)}>Delete</Button></td>
                                        </tr>
                                    ))
                                }
                                </tbody>
                            </table>
                        </>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <ButtonGroup>
                        <Button onClick={handleAddPair} style={{ margin: '0 2px' }}>Add New Value</Button>
                        <Button variant="primary" style={{ margin: '0 2px' }}
                                disabled={isFormInvalid()}
                                onClick={handleSaveCatAttrChanges}>
                            Save
                        </Button>
                    </ButtonGroup>
                </Modal.Footer>
            </Modal>
        );
    }

    const EditCategoryEinheitModal = ({risksItem}) => {
        if (risksItem == null || !('units' in risksItem)) {
            return null;
        }
        const [name, setName] = useState(risksItem.name);
        const [description, setDescription] = useState(risksItem.description);
        const [units, setUnits] = useState(risksItem.units);

        useEffect(() => {
            setName(risksItem.name);
            setDescription(risksItem.description);
            setUnits(risksItem.units);
        }, [risksItem]);

        const isFormInvalid = () => {
            return name.trim() === '' || units.length === 0;
        }

        const handleSaveCatUnitsChanges = async () => {
            const updatedItem = { ...risksItem, name, description, units };
            const updated_stats = await updateCategoryUnits(updatedItem);
            handleEditCatUnitsModalClose();
            setLoading(true);
            setCatAttrStats(updated_stats.response);
            setLoading(false);
        }

        return (
            <Modal show={showEditCatUnits} dialogClassName="risks-child-modal" onHide={handleEditCatUnitsModalClose}
                    aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit {name}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="risks-child-modal-body">
                    {
                        <>
                            <h6>Name</h6>
                            <div>
                                <input type="text" className="risks-child-modal-input" value={name}
                                       onChange={(e) => {
                                           setName(e.target.value);
                                       }} />
                            </div>
                            <br />
                            <h6>Description</h6>
                            <div>
                                <input type="text" className="risks-child-modal-input" value={description}
                                       onChange={(e) => {
                                           setDescription(e.target.value);
                                       }}
                                       placeholder="Description" />
                            </div>
                            <br />
                            <h6>Einheiten</h6>
                            <div className="einheit-child-modal">
                                <Multiselect
                                    placeholder={'Einheit'}
                                    isObject={false}
                                    options={['St', 'm', 'm2', 'm3', 'cm', 'cm2', 'psch', 'pau', 'h', 'd', 'Wo', 'Mt', 'a', 'kg', 't', 'l']}
                                    onSelect={(selectedList, selectedItem) => {
                                        units.push(selectedItem);
                                        setUnits([...units]);
                                    }}
                                    onRemove={(selectedList, removeItem) => {
                                        let unitsFiltered = units.filter((el) => el !== removeItem);
                                        setUnits([...unitsFiltered]);
                                    }}
                                    avoidHighlightFirstOption={true}
                                    selectedValues={units}
                                    showCheckbox
                                />
                            </div>
                        </>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <ButtonGroup>
                        <Button variant="primary" style={{ margin: '0 2px' }}
                                disabled={isFormInvalid()}
                                onClick={handleSaveCatUnitsChanges}>
                            Save
                        </Button>
                    </ButtonGroup>
                </Modal.Footer>
            </Modal>
        );
    }

    return (
        <>
            <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton onHide={handleOnHide}>
                    <Modal.Title>Potential Risks - categories and attributes</Modal.Title>
                </Modal.Header>
                <Modal.Body className="risks-wider-modal-body">
                    {
                        <>
                            <div className="search-container">
                                <input
                                    className="risks-search-input"
                                    type="text"
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    placeholder="Search category or attribute"
                                />
                            </div>
                            <Loader show={loading} message={<span>
                            <Oval
                                visible={true}
                                height="50"
                                width="50"
                                color="#ffffff"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                type="Oval" /></span>}>
                                <table className="risks-table">
                                    <thead>
                                    <tr>
                                        <th>Category</th>
                                        <th>AI-Tag</th>
                                        <th>Name for Report</th>
                                        <th>Description</th>
                                        <th>Values</th>
                                        <th>Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>{renderItems}</tbody>
                                </table>
                            </Loader>
                            <br />
                            <div className="risks-pagination-container">
                                <ul className="risks-pagination">
                                    {pageNumbers.map((number) => (
                                        <li key={number}>
                                            <button
                                                className={`risks-pagination-button ${currentPage === number ? 'active' : ''}`}
                                                onClick={() => handlePageChange(number)}
                                            >
                                                {number}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <Row>
                                <Col sm="11" style={{textAlign: "right", paddingRight: "30px", paddingBottom: "20px"}}>
                                      <Form.Check type="checkbox" checked={isEinheit}
                                                  onChange={(e) => setIsEinheit(e.target.checked)}
                                                  label="Attribute type - Einheit"
                                                  style={{transform: "scale(1.2)"}} />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="2">
                                    <Form.Group>
                                        <Form.Control as="select" value={category}
                                                      onChange={handleCategorySelect} style={{width: "180px"}}>
                                            <option value="">Select Category</option>
                                            {
                                                categories.map((cat, index) => (
                                                    <option value={cat} key={index}>{cat}</option>
                                                ))
                                            }
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm="2">
                                    {!isEinheit ? (
                                        <Form.Group>
                                            <Form.Control as="select" value={aiTag} style={{width: "180px"}}
                                                          onChange={handleAiTagSelect}>
                                                <option value="">Select AI-Tag</option>
                                                {
                                                    aiTags.map((aiTag, index) => (
                                                        <option value={aiTag} key={index}>{aiTag}</option>
                                                    ))
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                        ) :
                                       (
                                        <div className="einheit">
                                             <Multiselect
                                                placeholder={'Einheit'}
                                                isObject={false}
                                                options={['St','m','m2','m3','cm','cm2','psch','pau','h','d','Wo','Mt','a','kg','t','l']}
                                                onSelect={(selectedList, selectedItem) => {
                                                    selectedEinheits.push(selectedItem);
                                                    setSelectedEinheits([...selectedEinheits]);
                                                }}
                                                onRemove={(selectedList, removeItem) => {
                                                    let selectedEinheitsFiltered = selectedEinheits.filter((el) => el !== removeItem);
                                                    setSelectedEinheits([...selectedEinheitsFiltered]);
                                                }}
                                                avoidHighlightFirstOption={true}
                                                selectedValues={selectedEinheits}
                                                showCheckbox
                                            />
                                        </div>
                                         )
                                    }
                                </Col>
                                <Col sm="3">
                                    <Form.Group>
                                        <Form.Control type="text" value={name} style={{width: "274px"}}
                                                      onChange={(e) => setName(e.target.value)}
                                                      placeholder="Name of category attribute" />
                                    </Form.Group>
                                </Col>
                                <Col sm="4">
                                    <Form.Group>
                                        <Form.Control type="text" value={description} style={{width: "370px"}}
                                                      onChange={(e) => setDescription(e.target.value)}
                                                      placeholder="Description of category attribute" />
                                    </Form.Group>
                                </Col>
                                <Col sm="1">
                                    <Button variant="primary" type="button"
                                            onClick={handleAddCategoryAttribute}
                                            disabled={validateForm()}>Add</Button>
                                </Col>
                            </Row>
                        </>
                    }
                </Modal.Body>
                {/*<Modal.Footer>*/}
                {/*    <Button variant="primary" onClick={handleOnHide}>Close</Button>*/}
                {/*</Modal.Footer>*/}
            </Modal>
            <EditCategoryAttributeModal risksItem={risksItem}/>
            <EditCategoryEinheitModal risksItem={risksItem}/>
        </>
    );
}

export default RisksDetectionModal;